import React from "react";

// Real App Store ID 6756507411 (from App Store Connect).
const APP_STORE_IOS = "https://apps.apple.com/app/runcards/id6756507411";
// Play package matches the app's real applicationId (mobile/app.config.js).
const PLAY_STORE = "https://play.google.com/store/apps/details?id=cards.run.runcards";

const AppleIcon = () => (
  <svg className="h-6 w-6" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
  </svg>
);

const GooglePlayIcon = () => (
  <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden>
    <path
      fill="currentColor"
      d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.5,12.92 20.16,13.19L17.89,11.93L16.21,10.25L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"
    />
  </svg>
);

/**
 * StoreButtons — the App Store + Google Play CTAs, extracted so they can be
 * dropped anywhere (hero, a footer CTA, the header, etc.). `variant` adapts the
 * look to the background it sits on:
 *   - "dark" (default): solid black buttons — for light backgrounds
 *   - "light": white buttons — for dark backgrounds (e.g. the hero image)
 */
const VARIANTS = {
  dark: "bg-black text-white hover:bg-neutral-800",
  light: "bg-white text-runcards-text-primary shadow-lg hover:bg-white/90",
  glass: "border border-white/30 bg-white/[0.12] text-white hover:border-white/45 hover:bg-white/20",
};

// Liquid-glass material — matches the hero search bar / toggle treatment.
const GLASS_STYLE = {
  backdropFilter: "blur(20px) saturate(180%)",
  WebkitBackdropFilter: "blur(20px) saturate(180%)",
  boxShadow:
    "inset 0 1px 0 rgba(255,255,255,0.25), inset 0 0 0 1px rgba(255,255,255,0.05), 0 8px 28px rgba(0,0,0,0.22)",
};

const StoreButton = ({ href, ariaLabel, icon, label, variant }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={ariaLabel}
    className={`inline-flex items-center justify-center gap-2 rounded-xl px-5 py-3 font-runcards-bold text-sm transition-all ${VARIANTS[variant] || VARIANTS.dark}`}
    style={variant === "glass" ? GLASS_STYLE : undefined}
  >
    {icon}
    {label}
  </a>
);

const StoreButtons = ({ variant = "dark", className = "" }) => (
  <div className={`flex flex-col gap-3 sm:flex-row sm:gap-4 ${className}`}>
    <StoreButton
      variant={variant}
      href={APP_STORE_IOS}
      ariaLabel="Download Runcards on the App Store"
      label="App Store"
      icon={<AppleIcon />}
    />
    <StoreButton
      variant={variant}
      href={PLAY_STORE}
      ariaLabel="Get Runcards on Google Play"
      label="Google Play"
      icon={<GooglePlayIcon />}
    />
  </div>
);

export default StoreButtons;
